// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
import React from "react"
import { classNames } from "@plasmicapp/react-web"

export function GoogleLogoIcon(props) {
  const { className, style, title, ...restProps } = props
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 150 50"}
      height={"1em"}
      width={"1em"}
      style={{
        fill: "currentcolor",
        ...(style || {}),
      }}
      className={classNames("plasmic-default__svg", className)}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        d={
          "M63.833 25.641c0 6.94-5.51 12.055-12.27 12.055-6.762 0-12.27-5.114-12.27-12.055 0-6.989 5.508-12.054 12.27-12.054 6.76 0 12.27 5.065 12.27 12.054zm-5.372 0c0-4.337-3.193-7.304-6.899-7.304-3.705 0-6.898 2.967-6.898 7.304 0 4.294 3.193 7.305 6.898 7.305 3.706 0 6.9-3.017 6.9-7.305zm31.842 0c0 6.94-5.509 12.055-12.27 12.055-6.761 0-12.27-5.114-12.27-12.055 0-6.983 5.509-12.054 12.27-12.054 6.761 0 12.27 5.065 12.27 12.054zm-5.371 0c0-4.337-3.193-7.304-6.899-7.304s-6.899 2.967-6.899 7.304c0 4.294 3.193 7.305 6.899 7.305s6.899-3.017 6.899-7.305zm30.739-11.326v21.642c0 8.902-5.327 12.538-11.625 12.538-5.928 0-9.497-3.908-10.842-7.104l4.676-1.918c.833 1.962 2.874 4.277 6.16 4.277 4.032 0 6.53-2.451 6.53-7.065V34.95h-.188c-1.202 1.462-3.518 2.74-6.441 2.74-6.116 0-11.719-5.25-11.719-12.006 0-6.805 5.603-12.098 11.719-12.098 2.917 0 5.234 1.277 6.441 2.696h.188V14.32h5.101v-.006zm-4.721 11.37c0-4.245-2.873-7.348-6.529-7.348-3.706 0-6.81 3.103-6.81 7.348 0 4.2 3.104 7.26 6.81 7.26 3.656 0 6.529-3.06 6.529-7.26zM124.081 1.63v35.326h-5.239V1.63h5.239zm20.415 27.979l4.17 2.739c-1.346 1.962-4.589 5.342-10.192 5.342-6.948 0-12.137-5.293-12.137-12.054 0-7.169 5.233-12.054 11.536-12.054 6.348 0 9.453 4.978 10.467 7.668l.557 1.37-16.351 6.674c1.252 2.418 3.199 3.652 5.928 3.652 2.736 0 4.633-1.326 6.022-3.337zm-12.832-4.337l10.93-4.473c-.601-1.505-2.41-2.554-4.539-2.554-2.729 0-6.529 2.375-6.391 7.027zM19.462 22.506V17.39h17.487c.17.892.259 1.946.259 3.087 0 3.837-1.064 8.582-4.495 11.962-3.336 3.424-7.599 5.25-13.246 5.25C9 37.69.2 29.288.2 18.973S9 .255 19.467.255c5.79 0 9.916 2.24 13.015 5.158L28.82 9.022c-2.222-2.055-5.233-3.652-9.358-3.652-7.644 0-13.622 6.07-13.622 13.603 0 7.533 5.978 13.603 13.622 13.603 4.957 0 7.78-1.962 9.59-3.745 1.466-1.445 2.432-3.51 2.812-6.331l-12.402.006z"
        }
        fill={"currentColor"}
      ></path>
    </svg>
  )
}

export default GoogleLogoIcon
/* prettier-ignore-end */
